import React from 'react'

const Menssage = props => {    
    const classes = "message " + props.type;
    return (        
      <div className={classes}>{props.message}</div>        
    );
  };

export default Menssage;